// Auto-generated image registry for Mídias com Propósito
export const IMAGES = {
  // Logos — Logotipos (footer)
  LOGOTIPO_01: '/images/M%C3%ADdas%20-%20Logotipo_01.png',
  LOGOTIPO_02: '/images/M%C3%ADdas%20-%20Logotipo_02.png',
  LOGOTIPO_03: '/images/M%C3%ADdas%20-%20Logotipo_03.png',

  // Logos — Símbolos (header)
  SIMBOLO_01: '/images/M%C3%ADdias%20-%20Simbolo_01.png',
  SIMBOLO_02: '/images/M%C3%ADdias%20-%20Simbolo_02.png',
  SIMBOLO_03: '/images/M%C3%ADdias%20-%20Simbolo_03.png',
  SIMBOLO_04: '/images/M%C3%ADdias%20-%20Simbolo_04.png',
  SIMBOLO_05: '/images/M%C3%ADdias%20-%20Simbolo_05.png',

  // Marina photos
  MARINA_HERO: '/images/marina_hero.jpg',
  MARINA_PHOTO_1: '/images/marina_photo_1.jpg',

  // Cases
  CASE_TRAVESSIA: '/images/case_travessia.jpg',
  CASE_ALDEIA: '/images/case_aldeia.png',
  CASE_LAS_NENAS: '/images/case_las_nenas.jpg',
  CASE_ARVOREDO: '/images/case_arvoredo.png',
  CASE_ENCONTRO: '/images/cropped_image_0_1775589151123362446.jpg',

  // Testimonials
  TESTIMONIAL_TATIANA: '/images/testimonial_tatiana.png',
  TESTIMONIAL_LIDI: '/images/testimonial_lidi.png',
  TESTIMONIAL_ANA: '/images/testimonial_ana_ramos.png',
  TESTIMONIAL_FLAVIA: '/images/testimonial_flavia.png',
  TESTIMONIAL_GIOVANNA: '/images/testimonial_giovanna.png',
  TESTIMONIAL_FERNANDO: '/images/testimonial_fernando.png',

  // Client logos (valid transparent PNGs — no solid white squares)
  CLIENT_LOGO_2: '/images/client_logo_2.png',
  CLIENT_LOGO_5: '/images/client_logo_5.png',
  CLIENT_LOGO_7: '/images/client_logo_7.png',
  CLIENT_LOGO_9: '/images/client_logo_9.png',
  CLIENT_LOGO_11: '/images/client_logo_11.png',
  CLIENT_LOGO_15: '/images/client_logo_15.png',
} as const;

export type ImageKey = keyof typeof IMAGES;
